import { ApexOptions } from 'apexcharts'
import type { Fmt } from './format'
import type { T } from './i18n'

/**
 * ApexCharts draws its own month/day names (datetime axis) and toolbar tooltips in English unless it
 * is given a locale. This builds one from the application's language.
 */
export function apexLocale(
  t: T,
  f: Fmt
): Pick<NonNullable<ApexOptions['chart']>, 'locales' | 'defaultLocale'> {
  const months = Array.from({ length: 12 }, (_, i) => i + 1)
  // Apex weeks start on Sunday: ISO weekday 7 first
  const days = [7, 1, 2, 3, 4, 5, 6]
  return {
    defaultLocale: 'app',
    locales: [
      {
        name: 'app',
        options: {
          months: months.map((m) => f.monthLong(m)),
          shortMonths: months.map((m) => f.monthShort(m)),
          days: days.map((d) => f.weekdayLong(d)),
          shortDays: days.map((d) => f.weekdayShort(d)),
          toolbar: {
            exportToSVG: t('PROFILES_DASHBOARD.CHART.EXPORT_SVG'),
            exportToPNG: t('PROFILES_DASHBOARD.CHART.EXPORT_PNG'),
            exportToCSV: t('PROFILES_DASHBOARD.CHART.EXPORT_CSV'),
            download: t('PROFILES_DASHBOARD.CHART.DOWNLOAD'),
            selection: t('PROFILES_DASHBOARD.CHART.SELECTION'),
            selectionZoom: t('PROFILES_DASHBOARD.CHART.SELECTION_ZOOM'),
            zoomIn: t('PROFILES_DASHBOARD.CHART.ZOOM_IN'),
            zoomOut: t('PROFILES_DASHBOARD.CHART.ZOOM_OUT'),
            pan: t('PROFILES_DASHBOARD.CHART.PAN'),
            reset: t('PROFILES_DASHBOARD.CHART.RESET'),
          },
        },
      },
    ],
  }
}
